<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Activity Tracker/Leads</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home/dashboard"><img
            src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <!-- Search Grid Start -->
    <div class="block">
      <div class="page-header">
        <span class="page-header__title">Activity Tracker/Leads</span>
      </div>
      <div class="Reports_form_div">
        <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="trackerSearchForm">
          <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
            <mat-form-field appearance="outline" class="w-100 custom-select">
              <mat-label>Technician</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="selectTechnician"
                     placeholder="Search business" (keyup)="filterBusinesses()"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = techniciansData"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.firstName }} {{ option.lastName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.selectTechnician.invalid"><i>Select technician</i></mat-hint>
              <mat-hint *ngIf="f.selectTechnician.valid"><i>Technician selected</i></mat-hint>
              <mat-error *ngIf="(f.selectTechnician.touched || f.selectTechnician.dirty || submitted) && f.selectTechnician.errors">
                <i *ngIf="f.selectTechnician.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100" formGroupName="dateRangeField">
              <mat-label>Date Range</mat-label>

              <mat-date-range-input [rangePicker]="picker"
                                    [max]="maxDate"
                                    (focus)="picker.open()"
                                    (click)="picker.open()">
                <input matStartDate placeholder="Start date" formControlName="start" readonly />
                <input matEndDate placeholder="End date" formControlName="end" readonly />
              </mat-date-range-input>

              <!-- Dynamic icon: calendar or clear (×) -->
              <button mat-icon-button
                matSuffix
                [ngStyle]="{
                  'z-index': 1000,
                  'position': 'relative',
                  'background': 'none',
                  'border': 'none',
                  'box-shadow': 'none',
                  'outline': 'none'
                }"
                (click)="picker.open()"
                aria-label="Toggle date">

                <!-- Show normal calendar icon if no filter applied -->
                <mat-icon>calendar_today</mat-icon>
              </button>

              <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
              <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
              <mat-hint><i>Date range selected</i></mat-hint>
              <mat-error *ngIf="submitted && (dateRangeField.get('start')?.hasError('required') || dateRangeField.get('end')?.hasError('required'))">
                <i>Date range is required.</i>
              </mat-error>
            </mat-form-field>

            <div class="form-field">
              <div class="buttons-div reports_search_div culture-search">
                <div class="transactions-button-container" (click)="searchData()">
                  <button class="transaction-submit-button">
                    <span class="icon"><img src="../../../../../../assets/images/New_Icons/show.svg"></span>
                    <span class="text">Show</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Search Grid Ends -->
    <div *ngIf="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <!-- Tab Grid Start -->
    <div class="block" style="margin-bottom: 0" *ngIf="mainTableData.length > 0 || leadsTableRecords.length > 0">
      <div class="nav_tabs_container">
        <ul>
          <li class="active" [ngClass]=" mainTableData.length > 0 ? 'active' : ''"><a data-toggle="tab"
                                                                                      (click)="allTab()">All</a></li>
          <li [ngClass]=" mainTableData.length == 0 ? 'active' : ''"><a data-toggle="tab"
                                                                        (click)="leadsTab()">Leads</a></li>
        </ul>
      </div>
      <!-- Tab Grid Ends -->
    </div>
    <div class="block activityblock">
      <!-- Customer Visit Scrrens Dialog-->
      <!-- For All Tabs -->
      <div *ngIf="isAllTabFalg && mainTableData && mainTableData.length > 0" class="visitBlock">
        <div class="activitiesObj">
          <span class="innerSquare">{{ mainTableData.length }}</span>
          <span>Total Visits</span>
        </div>
        <div class="innerSpace">
          <span class="lineWidth"></span>
        </div>
        <div class="activitiesObj">
          <span class="innerSquare">{{ totalActivities }}</span>
          <span>Total Activities</span>
        </div>
        <div class="innerSpace">
          <span class="lineWidth"></span>
        </div>
        <div class="activitiesObj">
          <span class="innerSquare">{{ locationsLength }}</span>
          <span>Locations</span>
        </div>
      </div>
      <!-- For Leads Tab -->
      <div *ngIf="isLeadsTabFlag  && leadsTableRecords.length > 0" class="visitBlock">
        <div class="activitiesObj">
          <span class="innerSquare">{{ totalLeads }}</span>
          <span>Total Leads</span>
        </div>
        <div class="innerSpace">
          <span class="lineWidth"></span>
        </div>
        <div class="activitiesObj">
          <span class="innerSquare">{{ totalConversions }}</span>
          <span>Converstions</span>
        </div>
        <div class="innerSpace">
          <span class="lineWidth"></span>
        </div>
        <div class="activitiesObj">
          <span class="innerSquare">{{ totalAreaofLeads }} acr</span>
          <span>Area of the Lead Size</span>
        </div>
        <div class="innerSpace">
          <span class="lineWidth"></span>
        </div>
        <div class="activitiesObj">
          <span class="innerSquare">{{ totalLeadLocations.length }}</span>
          <span>No of Locations</span>
        </div>
        <div class="innerSpace">
          <span class="lineWidth"></span>
        </div>
        <div class="activitiesObj">
          <span class="innerSquare">{{ shrimpRatio }}:{{ fishRatio }}</span>
          <span>Shrimp:Fish</span>
        </div>
      </div>
      <!-- Customer Visit Scrrens Dialog -->
      <div class="icon-block" *ngIf="isAllTabFalg && isMapsClicked && (mainTableData && mainTableData.length > 0)">
        <img src="../../../../../../assets/images/New_Icons/expand-icon.svg" title="Zoom in" (click)="openFullScreen()">
      </div>
      <!-- Excel Icon -->
      <div *ngIf="isAllTabFalg && mainTableData && mainTableData.length > 0" style="padding: 6px;">
          <span *ngIf="isAllTabFalg && mainTableData.length > 0" class="reportsLabel"
                style="font-size: 18px;">Report</span>
      </div>
      <div *ngIf="isLeadsTabFlag && leadsTableRecords.length > 0" style="padding: 6px;">
        <span class="reportsLabel" style="font-size: 18px;">Report</span>
        <span style="float: right;">
            <button (click)="exportExcel()" class="excelButton">
            <img src="../../../../../../assets/images/New_Icons/excel-download-icon.svg" height="60" width="60"/>
            </button>
          </span>
      </div>
      <!-- Excel Icon -->
      <!--All Table Start -->
      <div class="panel-bodyTable table-responsive"
           *ngIf="isAllTabFalg && mainTableData && mainTableData.length > 0">
        <table class="table table-striped table-bordered table-hover text-centre">
          <thead>
          <tr>
            <th *ngIf="tableHeaderFlag">TECHNICIAN</th>
            <th>DATE</th>
            <th>CUSTOMER</th>
            <th>Visit Remarks</th>
            <th>ACTIVITY</th>
          </tr>
          </thead>
          <tbody>
          <tr
            *ngFor="let activities of mainTableData | orderBy:'date':true | orderBy:'punchin':true">
            <td *ngIf="tableHeaderFlag">{{ activities.name }}</td>
            <td>{{ activities.date }}</td>
            <td>{{ activities.customer }}</td>
            <td style="word-break: normal;">{{ activities.visitRemarks }}</td>
            <td>
              <div class="dropdown">
                <button class="dropbtn" *ngIf="activities.activityArray.length > 0">
                  <span class="more-dot"></span>
                  <span class="more-dot"></span>
                  <span class="more-dot"></span>
                </button>
                <div class="dropdown-content">
                  <a *ngFor="let item of activities.activityArray">
                    <span>{{ item.activityName }}</span></a>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <!--pagination end-->
      </div>
      <!--All Table Ends -->
      <!--Leads Table Start -->
      <div class="panel-bodyTable table-responsive"
           *ngIf="isLeadsTabFlag && leadsTableRecords && leadsTableRecords.length > 0">
        <table class="table table-striped table-bordered table-hover text-centre">
          <thead>
          <tr>
            <th>STATUS</th>
            <th>STATUS DATE</th>
            <th>CUSTOMER</th>
            <th>MOBILE</th>
            <th>FARM AT</th>
            <th>PINCODE</th>
            <th>LOCATIONS</th>
            <th>CULTURE TYPE</th>
            <th>SPECIES</th>
            <th style="max-width: 118px; font-size: 11px;">TOTAL CULTURE <br> AREA (acr)</th>
            <th>PONDS</th>
            <th>REMARKS</th>
          </tr>
          </thead>
          <tbody>
          <tr
            *ngFor="let lead of leadsTableRecords">
            <td>{{ lead.type }}</td>
            <td>{{ lead.date | date: "dd-MMM-yyyy" }}</td>
            <td>{{ lead.customer }}</td>
            <td>{{ lead.mobile }}</td>
            <td>{{ lead.farmAt }}</td>
            <td>{{ lead.pincode }}</td>
            <td>{{ lead.locations }}</td>
            <td>{{ lead.cultureType }}</td>
            <td>{{ lead.species }}</td>
            <td>{{ lead.totalCultureArea }}</td>
            <td>{{ lead.ponds }}</td>
            <td>{{ lead.remarks }}</td>
          </tr>
          </tbody>
        </table>
        <!--pagination end-->
      </div>
      <!--Leads Table Ends -->
    </div>
    <div *ngIf="isAllTabFalg && mainTableData.length == 0 && !isLeadsTabFlag" class="block noDataClass">
      No Data is Available for selected criteria
    </div>
    <div *ngIf="isLeadsTabFlag && leadsTableRecords.length == 0" class="block noDataClass">
      No Leads is Available for selected criteria
    </div>
  </div>
</div>
